import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cdpres-spec-table',
  templateUrl: './cdpres-spec-table.component.html',
  styleUrls: ['./cdpres-spec-table.component.scss']
})
export class CDPResSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'totalPorts', 'occupancy', 'CDP-code', 'CDP-location', 'CDP-type'];
    super.onInit();
  }
}
